export enum NewDataHandlingMode {
    Append = 'append',
    Replace = 'replace',
}
